<template>
  <div class="productReturnCard" v-if="usernameMappings">
    <ItemFrame
      :itemCount="totalAllocations"
      :itemImageUrl="product.thumbnail"
      :itemName="product.title"
      :itemSku="qualification.productId"
    />
    <div class="itemQuantities">
      <PersonQuantity
        v-for="(shareBackItem, index) in shareBackList"
        :customerId="shareBackItem.customerId"
        :defaultName="defaultName"
        :index="index"
        :key="shareBackItem.customerId"
        :personName="usernameMappings[shareBackItem.customerId]"
        :quantityLabel="quantityLabel"
        :selectedValue="getSelectedValue(shareBackItem)"
        :totalQuantity="shareBackItem.quantity"
        :productSku="qualification.productId"
        @select="select"
      />
    </div>
  </div>
</template>

<script>
import ItemFrame from './ItemFrame.vue'
import PersonQuantity from './PersonQuantity.vue'

import { mapIdsToDisplayNames } from '../../js/VGHelper'

export default {
  components: {
    ItemFrame,
    PersonQuantity,
  },
  computed: {
    shareBackList() {
      return this.qualification.shareBackList.filter((item) => item.quantity > 0)
    },
    totalAllocations() {
      let total = 0
      this.qualification.shareBackList.forEach((element) => {
        total += element.quantity
      })
      return total
    },
    product() {
      return this.products.find(product =>
        product.equinoxProductId === this.qualification.productId ||
        product.id === this.qualification.productId ||
        (product.bundle && product.bundle.parentId && product.bundle.parentId === this.qualification.productId)
      )
    },
  },
  data() {
    return {
      tdc_partialReturnListTitle: '',
      tdc_noReturnsFound: '',
      selectedQuantities: {},
      usernameMappings: null
    }
  },
  methods: {
    getSelectedValue(shareBackItem) {
      if (this.partialReturnList &&
        shareBackItem &&
        shareBackItem.customerId &&
        this.partialReturnList[this.qualification.productId]
      ) {
        const result = this.partialReturnList[this.qualification.productId][shareBackItem.customerId]
        return result
      }
      return 0
    },
    select(event) {
      this.selectedQuantities[event.customerId] = event.quantity
      this.$emit('select', {
        sku: this.qualification.productId,
        selectedQuantities: this.selectedQuantities,
      })
    },
  },
  mounted() {
    this.qualification.shareBackList.forEach((element) => {
      this.totalAllocations += element.quantity
    })
  },
  props: {
    qualification: {
      type: Object,
      required: true,
    },
    defaultName: {
      type: String,
    },
    quantityLabel: {
      type: String,
    },
    partialReturnList: {
      type: Object,
    },
    products: {
      type: Object
    }
  },
  watch: {
    qualification: {
      immediate: true,
      handler: async function() {
        const ids = (this.qualification.shareBackList)
          .map(item => item.customerId)

        this.usernameMappings = await mapIdsToDisplayNames(ids)
      }
    }
  }
}
</script>

<style lang="scss">
  .productReturnCard {
    border-radius: 6px;
    border: 1px solid #BBBBCB;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    max-width: 820px;
    padding: 15px;
    background-color: white;
    overflow: visible;
  }
</style>
